export default {
  'notFound.title': 'Hay aksi! Sayfa Bulunamadı',
  'notFound.desc':
    'Hay aksi! Bir şeyler yanlış gitti. Aradığınız sayfa bulunamadı.',
  'notFound.toHome': 'Anasayfaya Dön',
};
